import { HeadMenuItemProps } from '../model/types'

export const useHeadMenuItem = ({
    toggleIcon,
    onToggle,
    onClickIcon,
    onClick,
}: Pick<HeadMenuItemProps, 'toggleIcon' | 'onToggle' | 'onClickIcon' | 'onClick'>) => {
    const handleClick = () => {
        if (toggleIcon && typeof onToggle === 'function') {
            onToggle()
        } else if (onClickIcon) {
            onClickIcon()
        } else if (onClick) {
            onClick()
        }
    }

    return { handleClick }
}